import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import Loading from "../components/Shared/Loading";

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { me, loading } = useAuth();

  if (loading) return <Loading />;
  if (!me) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
